export const useStyles = (theme) => ({
  root: {
    width: "100%",
    backdropFilter: `blur(4px)`,
    backgroundColor: `rgba(0, 0, 0, 0.5)`,
  },
  paper: {
    borderRadius: 20,
  },
  cancelButtonStyle: {
    borderRadius: 10,
    outline: "none",
    variant: "contained",
    color: "#181818",
    fontSize: 18,
    textTransform: "none",
    "&:hover": {
      backkgroundColor: "transparent",
    },
  },
  deleteButtonStyle: {
    borderRadius: 10,
    outline: "none",
    variant: "contained",
    color: "#ffffff",
    fontSize: 18,
    textTransform: "none",
    backgroundColor: "#d73b49 !important",
    outlineColor: "#d73b49 !important",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
});
